import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "../createAppSlice";
export interface CartSliceState {
  cartItem: CartItem;
  cartSummary: CartSummary;
  cartOffers: CartOffer[];
  status: "idle" | "loading" | "failed";
  guestId?: string;
  message?: string;
  customer: Customer;
  order: Order;
}

const initialState: CartSliceState = {
  cartItem: {} as CartItem,
  cartSummary: {} as CartSummary,
  cartOffers: [],
  status: "idle",
  message: "",
  customer: {} as Customer,
  order: {} as Order,
};

// If you are not using async thunks you can use the standalone `createSlice`.
export const cartSlice = createAppSlice({
  name: "cart",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: (create) => ({
    setCartItem: create.reducer((state, action: PayloadAction<CartItem>) => {
      state.cartItem = action.payload;
    }),
    setCartSummary: create.reducer(
      (state, action: PayloadAction<CartSummary>) => {
        state.cartSummary = action.payload;
      }
    ),
    setCartOffers: create.reducer(
      (state, action: PayloadAction<CartOffer[]>) => {
        state.cartOffers = action.payload;
      }
    ),
    setCustomer: create.reducer((state, action: PayloadAction<Customer>) => {
      state.customer = action.payload;
    }),
    setOrder: create.reducer((state, action: PayloadAction<Order>) => {
      state.order = action.payload;
    }),
  }),
  selectors: {
    getCartItems: (state) => state.cartItem,
    getCartOffers: (state) => state.cartOffers,
    getCartSummary: (state) => state.cartSummary,
    status: (state) => state.status,
  },
});

// Action creators are generated for each case reducer function.
export const {
  setCartItem,
  setCartOffers,
  setCartSummary,
  setCustomer,
  setOrder,
} = cartSlice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const { getCartItems, getCartOffers, getCartSummary, status } =
  cartSlice.selectors;
